import { Component, OnInit } from '@angular/core';
import { MainService } from '../../service/main.service';
import { ToasterServiceService } from '../../service/toaster.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Location } from '@angular/common';
import { ApiUrls } from '../../apiRouts';
import { environment } from '../../../environments/environment';
import { LocalStorageService } from '../../service/local-storage.service';
@Component({
  selector: 'app-memory-list',
  templateUrl: './memory-list.component.html',
  styleUrl: './memory-list.component.scss'
})
export class MemoryFolderListComponent implements OnInit{
  memoryForm: any = FormGroup;
  mainMemoryData: any;
  memoryData: any;
  userTypeId: any;
  submitted: boolean = false;
  buttonclick: boolean = false;
  baseUrl = environment.imageURL;
  subEventId: any;

  constructor(    
    private mainService: MainService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private localStorageService: LocalStorageService
  ) {
    this.userTypeId = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_type_id;

    this.memoryForm = this.fb.group({
      folder_name: ['', [Validators.required]],
    });

    this.route.params.subscribe((params: any) => {
      this.subEventId = params['sub_event'] || '';
    });
  }

  ngOnInit() {
    this.getMemoryList();
  }

  get f() {
    return this.memoryForm.controls;
  }

  getMemoryList() {
    this.mainService.getApi(ApiUrls.memoryAllList + this.subEventId).subscribe((res: any) => {
      if (res.status == 1) {
        this.mainMemoryData = res.gallery_folder;
        this.memoryData = res.gallery_folder;
      }
    });
  }

  AddMemoryFolder() {
    this.router.navigate(["/add-memory-Folder/" + this.subEventId]);
  }

  GoToGallery(data: any) {
    this.router.navigate(["/memorys-list/" + data.gallery_folder_id]);
  }


  applySearch(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    if (!filterValue) {
      this.memoryData = [...this.mainMemoryData];
      return;
    }
    this.memoryData = this.mainMemoryData.filter((data: any) => {
      return data.folder_name.toLowerCase().includes(filterValue)
    });
  }
  errorHandler(event: any) {
    event.target.src = "../../../assets/img/dhaduk-logo.png";
  }

}
